import { StyleSheet } from 'react-native';
import type { StylesMap } from 'Types';

const styles: StylesMap = {
    videoPlayer: {
        // position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        flex: 1,
        alignSelf: 'stretch',
        height: '100%',
        width: '100%',
        overflow: 'hidden'
    },
    miniVideoPlayer: {
        position: 'relative',
        height: '100%',
        flex: 4,
        width: '45%'
    },
    miniPlayerDetail: {
        flex: 5
    }
};

export default StyleSheet.create(styles);
